/* 
  利用开始月份和结束月份计算出中间的所有月份
  create by 李智惠 2021-10-21
*/
function computeMonths(dateRange) {
  let dates = [dateRange[0]];
  this.searchForm.dates = []; // 接收数据
  const startDate = new Date(dateRange[0]);
  const endDate = new Date(dateRange[1]);
  // 时间格式化函数，此处仅针对yyyy-MM的格式进行格式化
  const dateFormat = function(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    return year + '-' + month;
  }
  const monthNum = (endDate.getFullYear() * 12 + endDate.getMonth()) - (startDate.getFullYear() * 12 + startDate.getMonth()); // 获取月份差值
  for (let i = 0; i < monthNum; i++) {
    dates.push(dateFormat(new Date(startDate.setMonth(startDate.getMonth() + 1))));
  }

  // 特殊处理 添加日期值(注意：此值无效)
  dates.forEach(item => { 
    this.searchForm.dates.push(item + '-01');
  });
}
export default computeMonths;